import React from 'react';

import { Chip, Text } from '@change/ds-core-ui';
import { LocationPinIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useMostVisitedLocationSection } from './hooks';

export const MostVisitedLocationSection: React.FC = () => {
	const { locations } = useMostVisitedLocationSection();

	return (
		<div className="space-y-6">
			<Text as="h2" variant="heading" size="small">
				<Translate value="corgi.location_page_sitemap.most_visited.title" />
			</Text>

			<div className="flex flex-wrap gap-2">
				{locations.map(({ location, slug }) => (
					<Chip
						leadingIcon={<LocationPinIcon />}
						key={slug}
						data-qa={`${location}-most-visited-chip`}
						as="a"
						size="large"
						href={`/local/${encodeURIComponent(slug)}?source_location=location-sitemap-most-visited-section`}
					>
						{location}
					</Chip>
				))}
			</div>
		</div>
	);
};
